import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Chips, CHIPS_COLOR, RadioCardButton } from 'veloe-ds';
import ScriptTag from 'react-script-tag';

import './tipoPagamento.scss';
import {
  tipoPagamento,
  salvaValorRecarga,
  salvarOndeUsar,
} from '../../actions/pedidoActions';

import { adaptandoCodigosPromocionais } from '../../utils/codigoPromocional';
import { APP_PAGES } from '../../routes';
import { modalInformativo, modalPagamento } from '../../Components/Modais';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import planoFCG from '../../mutations/plano';
import { withSnackbar } from 'notistack';
import {
  eventTrackBasic,
  eventTrackRoute,
  eventTrackEcommerce,
} from '../../utils/pushDataLayer.js';

/**
 * Exibe as informações Pagamento
 * A lista de pagamentos:
 * id: inteiro,
 * titulo: tipo de pagamento,
 * texto: 'descrição,
 * temMensalidades: informação sobre a mensalidade {temMensalidade: bool, titulo: informação, texto: descrição adicional},
 * ehRecomendado: indica se é o sugerido {ehRecomendado: bool, label: texto de destaque},
 * valor: string,
 * modal: informações para exibir na modal: {titulo: Título, cards: lista com: id: inteiro, icone: imagem, texto: descrição},
 *
 * Salva as informações do id da lista escolhido antes de ir para o proximo step
 * */
const TipoPagamento = ({
  pedido,
  salvaValorRecarga,
  history,
  activeLoader,
  inactiveLoader,
  tipoPagamento: reduxTipoPagamento,
  salvarOndeUsar,
}) => {
  const {
    tipoPagamento: pedidoTipoPagamento,
    ondeUsar: pedidoOndeUsar,
    codigoPromocional,
  } = pedido;
  const listCompletaValores = codigoPromocional.planos.todos.filter(
    (element) => element.id === 'ped-est',
  );
  const [botaoContinuar, setBotaoContinuar] = useState(true);
  const [list, setList] = useState(
    adaptandoCodigosPromocionais(listCompletaValores),
  );
  const [tipoPagamento, setTipoPagamento] = useState(pedidoTipoPagamento);
  const [ondeUsar] = useState(pedidoOndeUsar);
  const [openModalInformativo, setOpenModalInformativo] = useState(false);
  const [textoTermos, setTextoTermos] = useState('');

  const RECARGA_AUTOMATICA = list.find(
    (obj) => obj.id === 'recarga-automatica',
  );
  const POS_PAGO = list.find((obj) => obj.id === 'pos-pago');

  const RECARGA_VALOR = `R$${RECARGA_AUTOMATICA?.valorTarifa} após o período promocional`;
  const POS_VALOR = `R$${POS_PAGO?.valorTarifa} após o período promocional`;

  const retornoTipoPagamentoFGC = {
    'recarga-automatica': {
      tipoPlano: RECARGA_AUTOMATICA.tipoPlano,
      produtoId: RECARGA_AUTOMATICA.idProduto,
      valor: RECARGA_AUTOMATICA.valorTarifa,
      codigoPromocional: RECARGA_AUTOMATICA.codigoPromocional,
    },
    'pos-pago': {
      tipoPlano: POS_PAGO.tipoPlano,
      produtoId: POS_PAGO.idProduto,
      valor: POS_PAGO.valorTarifa,
      codigoPromocional: POS_PAGO.codigoPromocional,
    },
  };

  useEffect(() => {
    if (tipoPagamento !== '') {
      selecionaTipoPagamento(tipoPagamento, true);
    }
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }

    eventTrackRoute('tipo-pagamento');
  }, [history, selecionaTipoPagamento, tipoPagamento]);

  const selecionaTipoPagamento = useCallback(
    (item, flag) => {
      if (item.includes('pos')) {
        salvaValorRecarga(0);
      }

      setTipoPagamento(item);
      setBotaoContinuar(false);

      if (flag) {
        eventTrackBasic('clique:opcao', `tipo-pagamento:${item}`);
        eventTrackEcommerce(
          pedido,
          [retornoTipoPagamentoFGC, item],
          ['detail', 'produto'],
        );
      }

      manterCheckbox(item.id);
    },
    [manterCheckbox, pedido, retornoTipoPagamentoFGC, salvaValorRecarga],
  );

  const manterCheckbox = useCallback(
    (itemID) => {
      for (let i = 0; i < list.length; i++) {
        list[i].checkbox = list[i].id === itemID;
        setList(list);
      }
    },
    [list],
  );

  const chamaFuncRand = async () => {
    selecionaTipoPagamento(tipoPagamento, false);
    const proposta = JSON.parse(localStorage.getItem('proposta'));

    const plano = list.filter((element) => element.id === tipoPagamento)[0];

    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    activeLoader();
    veloeGraphQlApi(planoFCG, {
      idProposta: proposta.dados.id,
      captchaResponse: reCaptcha,
      ...retornoTipoPagamentoFGC[plano.id],
    })
      .then((data) => {
        const { dados, validatorResponse } = data['planoFCG'];
        if (dados) {
          eventTrackEcommerce(
            pedido,
            [retornoTipoPagamentoFGC, plano.id],
            ['add', 'produto'],
          );
          inactiveLoader();
          history.push(
            tipoPagamento === 'recarga-automatica'
              ? APP_PAGES.RECARGA_AUTOMATICA
              : APP_PAGES.REVISE_COMPRA,
          );
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            setTextoTermos(error.message);
            setOpenModalInformativo(true);
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        setTextoTermos(err.message);
        setOpenModalInformativo(true);
      });

    reduxTipoPagamento(tipoPagamento);
    salvarOndeUsar(plano);
  };

  const renderizaRadioButtons = () => {
    console.log('list:')
    console.log(list)
    const values = list.map((item, index) => (
      {
        id: item.id,
        key: `value-${item.id}`,
        value: (
          <div className="containerCard">
            <div className="containerTextCard">
              {item.ehRecomendado && (
                <Chips
                  {...{
                    color: CHIPS_COLOR.PURPLE,
                    label: item.ehRecomendado.label,
                  }}
                />
              )}
              <span className="tituloCard">{item.titulo}</span>
              <span className="textoCard">{item.texto}</span>
              {ondeUsar.temMensalidade && (
                <div className="containerMensalidadesTipoPagamento">
                  <div className="tituloMensalidades">
                    {item.id === 'pos-pago'
                      ? `${index === 0 ? 12 : POS_PAGO?.mesesBonificacao} mensalidades grátis`
                      : `${index === 0 ? 12 : RECARGA_AUTOMATICA?.mesesBonificacao} mensalidades grátis`}
                  </div>
                  <div className="textoMensalidades">
                    {item.id === 'pos-pago' ? `${POS_VALOR}` : `${RECARGA_VALOR}`}
                  </div>
                </div>
              )}
              {modalPagamento(
                item.modal,
                ondeUsar.texto === 'Pedágios/Estacionamentos',
              )}
            </div>
          </div>
        ),
      }
    ));

    return (
      <RadioCardButton
        key="radio-cards"
        values={values}
        onBg="light"
        cardSize="lg"
        value={tipoPagamento}
        onChange={(value) => {
          setTipoPagamento(value);
          setBotaoContinuar(false);
        }}
      />
    );
  };

  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <label className="areaTexto">Selecione o tipo de pagamento</label>
        </div>
      </div>
      <div className="containerArea">
        <div className="containerTipoPagamento">
          {renderizaRadioButtons()}
          <div className="stack-button-container" />
          <Button
            className="stack-button-full"
            {...{
              color: 'primary',
              disabled: botaoContinuar,
              label: 'Continuar',
              id: 'btn-continuar',
            }}
            onClick={chamaFuncRand}
          />
        </div>
      </div>
      {openModalInformativo &&
        modalInformativo(
          true,
          () => {
            setOpenModalInformativo(false);
          },
          'Ops!',
          textoTermos,
        )}
      <ScriptTag
        type="text/javascript"
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
      />
    </div>
  );
};

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tipoPagamento: (tipo) => dispatch(tipoPagamento(tipo)),
    salvarOndeUsar: (onde) => dispatch(salvarOndeUsar(onde)),
    salvaValorRecarga: (valor) => dispatch(salvaValorRecarga(valor)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(TipoPagamento));
